import * as React from "react";
import styled, { css } from "../../../styled/index";

export interface TopNavMenuItemProps {
  icon?: React.ReactNode;
  text?: string;
  onClick: () => void;
  active?: boolean;
  fontType?: "header" | "body";
}

export interface TopNavMenuProps extends React.MenuHTMLAttributes<HTMLMenuElement> {
  align: "left" | "right";
  fontType?: "header" | "body";
  items: TopNavMenuItemProps[];
}

const Wrapper = styled("nav")<TopNavMenuProps>`
  ${({align}) => align === "left" ? 
    css`
       a { margin-right: 18px; }
       a:last-child { margin-right: 0; } 
    ` : 
    css`
       a { margin-left: 18px; }
       a:first-child { margin-left: 0; } 
    `};
`;

const Item = styled("a")<TopNavMenuItemProps>`
  font-family: ${({fontType, theme}) => fontType === "body" ? theme.font.body : theme.font.header};
  font-size: ${({theme}) => theme.font.size + 1}px;
  color: ${({ active, theme }) => active ? theme.colors.primary : theme.top_nav.text_color};
  transition: 0.3s color;
  &:hover {
    color: ${({theme}) => theme.colors.primary};
  }
`;

export const TopNavMenu: React.SFC<TopNavMenuProps> = (props) => (
  <Wrapper {...props}>
    {props.items.map((i, k) => (
      <Item key={k} {...i}>
        {!!i.icon && <span className={i.text ? "m-r-2" : ""}>{i.icon}</span>}
        {i.text}
      </Item>
    ))}
  </Wrapper>
);
